// extracted by mini-css-extract-plugin
module.exports = {"overlay":"A","overlayAfterOpen":"B","modal":"C","overlayBeforeClose":"D","modalAfterOpen":"E","modalBeforeClose":"F","modalBody":"G","modalCloseIcon":"H"};